import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import './CustomizeSubmissionDomain.css';

const CustomizeSubmissionDomain = () => {
    const navigate = useNavigate();
    const [domains, setDomains] = useState([{ mainDomain: '', subDomains: [''] }]);

    // Handle changes in input fields
    const handleInputChange = (index, type, value) => {
        const newDomains = [...domains];
        if (type === 'mainDomain') {
            newDomains[index].mainDomain = value;
        } else {
            newDomains[index].subDomains[0] = value;
        }
        setDomains(newDomains);
    };

    // Add a new domain and subdomain input field
    const addDomainField = () => {
        setDomains([...domains, { mainDomain: '', subDomains: [''] }]);
    };

    // Remove a domain
    const removeDomain = (index) => {
        if (domains.length > 1) {
            const newDomains = domains.filter((_, i) => i !== index);
            setDomains(newDomains);
        }
    };

    // Add more subdomains for a specific main domain
    const addSubDomain = (index) => {
        const newDomains = [...domains];
        newDomains[index].subDomains.push('');
        setDomains(newDomains);
    };

    // Remove a subdomain
    const removeSubDomain = (domainIndex, subDomainIndex) => {
        const newDomains = [...domains];
        if (newDomains[domainIndex].subDomains.length > 1) {
            newDomains[domainIndex].subDomains = newDomains[domainIndex].subDomains.filter(
                (_, i) => i !== subDomainIndex
            );
            setDomains(newDomains);
        }
    };

    // Handle subdomain input change
    const handleSubDomainChange = (domainIndex, subDomainIndex, value) => {
        const newDomains = [...domains];
        newDomains[domainIndex].subDomains[subDomainIndex] = value;
        setDomains(newDomains);
    };

    // Handle form submission to store data in the database
    const handleSubmit = async () => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/cutomize-domains`,
                { domains }
            );

            Swal.fire({
                icon: 'success',
                title: 'Saved!',
                text: 'Domains have been successfully saved.',
                confirmButtonColor: '#5e71f6',
            }).then(() => {
                navigate('/submission-guideline');
            });
        } catch (error) {
            console.error('Error saving data:', error);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong while saving domains!',
                confirmButtonColor: '#5e71f6',
            });
        }
    };

    return (
        <div className="domain-manager-wrapper">
            <div className="domain-manager-container">
                <div className="header-section">
                    <h1 className="domain-manager-title">Customize Submission Domain</h1>
                    <p className="domain-manager-subtitle">
                        Define main domains and their associated subdomains for paper submissions
                    </p>
                </div>

                <div className="domains-list">
                    {domains.map((domain, index) => (
                        <div key={index} className="domain-card">
                            <div className="domain-card-header">
                                <h3 className="domain-card-title">Domain {index + 1}</h3>
                                {domains.length > 1 && (
                                    <button
                                        onClick={() => removeDomain(index)}
                                        className="remove-domain-btn"
                                        title="Remove Domain"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>

                            <div className="input-group">
                                <label className="input-label">Main Domain</label>
                                <input
                                    type="text"
                                    placeholder="e.g., Computer Science, Engineering, Medical Science"
                                    value={domain.mainDomain}
                                    onChange={(e) => handleInputChange(index, 'mainDomain', e.target.value)}
                                    className="domain-input"
                                />
                            </div>

                            <div className="subdomains-section">
                                <label className="input-label">Subdomains</label>
                                <div className="subdomains-list">
                                    {domain.subDomains.map((subDomain, subIndex) => (
                                        <div key={subIndex} className="subdomain-item">
                                            <input
                                                type="text"
                                                placeholder={`Subdomain ${subIndex + 1}`}
                                                value={subDomain}
                                                onChange={(e) => handleSubDomainChange(index, subIndex, e.target.value)}
                                                className="subdomain-input"
                                            />
                                            {domain.subDomains.length > 1 && (
                                                <button
                                                    onClick={() => removeSubDomain(index, subIndex)}
                                                    className="remove-subdomain-btn"
                                                    title="Remove Subdomain"
                                                >
                                                    ✕
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <button
                                    onClick={() => addSubDomain(index)}
                                    className="add-subdomain-btn"
                                >
                                    + Add Subdomain
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="action-buttons">
                    <button onClick={addDomainField} className="add-main-domain-btn">
                        + Add Main Domain
                    </button>
                    <button onClick={handleSubmit} className="save-domains-btn">
                        Save Domains
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomizeSubmissionDomain;
